import { render, staticRenderFns } from "./SubmenuNav_Button.vue?vue&type=template&id=1fa17db2&scoped=true&"
import script from "./SubmenuNav_Button.vue?vue&type=script&lang=js&"
export * from "./SubmenuNav_Button.vue?vue&type=script&lang=js&"
import style0 from "./SubmenuNav_Button.vue?vue&type=style&index=0&id=1fa17db2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa17db2",
  null
  
)

export default component.exports